import { takeLatest } from 'redux-saga/effects';
import { FETCH_MY_CASH_CLOSE_REQUEST } from '../../redux/modules/myCashClose/myCashClose-actions';
import fetchMyCashCloseWorkerSaga from './myCashCloseWorkerSaga';

export default function* fetchMyCashCloseWatcher() {
    yield takeLatest(FETCH_MY_CASH_CLOSE_REQUEST, fetchMyCashCloseWorkerSaga);
}
